import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'only-admin',
  templateUrl: './only-admin.component.html',
  styleUrls: ['./only-admin.component.scss']
})
export class OnlyAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
